var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-people",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 5.83333C13.3337 7.67428 11.8413 9.16667 10.0003 9.16667C8.15938 9.16667 6.66699 7.67428 6.66699 5.83333C6.66699 3.99238 8.15938 2.5 10.0003 2.5C11.8413 2.5 13.3337 3.99238 13.3337 5.83333ZM11.667 5.83333C11.667 6.75381 10.9208 7.5 10.0003 7.5C9.07985 7.5 8.33366 6.75381 8.33366 5.83333C8.33366 4.91286 9.07985 4.16667 10.0003 4.16667C10.9208 4.16667 11.667 4.91286 11.667 5.83333Z",
    fill: "#7E8A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 12.5C14.167 12.0398 13.7939 11.6667 13.3337 11.6667H6.66699C6.20675 11.6667 5.83366 12.0398 5.83366 12.5V17.5H4.16699V12.5C4.16699 11.1193 5.28628 10 6.66699 10H13.3337C14.7144 10 15.8337 11.1193 15.8337 12.5V17.5H14.167V12.5Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c98f5a88.svg";
export { ForwardRef as ReactComponent };